import { GraphQLClient } from 'graphql-request';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `AWSEmail` scalar type provided by AWS AppSync, represents an Email address string that complies with [RFC 822](https://www.ietf.org/rfc/rfc822.txt). For example, "**username@example.com**" is a valid Email address. */
  AWSEmail: any;
};

export type IAboutDetails = {
  btnHeroLink?: Maybe<Scalars['String']>;
  btnHeroText?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imgInitial?: Maybe<Scalars['String']>;
  supportingCopy?: Maybe<Scalars['String']>;
  testimonialWaterMark?: Maybe<Scalars['String']>;
  testimonialsTitle?: Maybe<Scalars['String']>;
  trustedTitle?: Maybe<Scalars['String']>;
  upcomingEventTitle?: Maybe<Scalars['String']>;
  upcomingEventWaterMark?: Maybe<Scalars['String']>;
};

export type IAboutDetailsData = {
  btnHeroLink?: Maybe<Scalars['String']>;
  btnHeroText?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imgInitial?: Maybe<Scalars['String']>;
  supportingCopy?: Maybe<Scalars['String']>;
  testimonialWaterMark?: Maybe<Scalars['String']>;
  testimonialsTitle?: Maybe<Scalars['String']>;
  trustedTitle?: Maybe<Scalars['String']>;
  upcomingEventTitle?: Maybe<Scalars['String']>;
  upcomingEventWaterMark?: Maybe<Scalars['String']>;
};

export type IAboutFeature = {
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type IAboutFeatureData = {
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type IAboutPayload = {
  about?: Maybe<IAboutpageData>;
  error?: Maybe<Scalars['String']>;
};

export type IAboutpageData = {
  aboutFeatures?: Maybe<Array<Maybe<IAboutFeature>>>;
  details?: Maybe<IAboutDetails>;
  testimonials?: Maybe<Array<Maybe<ITestimonial>>>;
  trustedBy?: Maybe<Array<Maybe<ITrustedBy>>>;
  upcomingEvents?: Maybe<Array<Maybe<IUpcomingEvent>>>;
};

export type IAttendEventResponse = {
  attendees?: Maybe<Array<Maybe<Scalars['String']>>>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<IEventResponse>;
  eventId?: Maybe<Scalars['String']>;
};

export type IAttendeeType = {
  attendDateAndTime?: Maybe<Scalars['String']>;
  userDisplayName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IAuthorization = {
  authState?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IAuthorizationPayload = {
  authorization?: Maybe<IAuthorization>;
  error?: Maybe<Scalars['String']>;
};

export type IAvailableActionsType = {
  archive?: Maybe<Scalars['Boolean']>;
  edit?: Maybe<Scalars['Boolean']>;
  finish?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['Boolean']>;
};

export type IAvailableActionsTypeV2 = {
  archive?: Maybe<Scalars['Boolean']>;
  edit?: Maybe<Scalars['Boolean']>;
  finish?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['Boolean']>;
};

export type ICategoryResponseV2 = {
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  thumbnail: Scalars['String'];
};

export type IChannel = {
  banner?: Maybe<Scalars['String']>;
  channelArn?: Maybe<Scalars['String']>;
  channelData?: Maybe<IChannelData>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  ingestServer?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  playbackUrl?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
  subId?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  watermark?: Maybe<Scalars['String']>;
};

export type IChannelData = {
  banner?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  ingestServer?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  playbackUrl?: Maybe<Scalars['String']>;
  streamArn?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IChannelPayload = {
  channel?: Maybe<IChannel>;
  error?: Maybe<Scalars['String']>;
};

export type IChannelResponse = {
  channelData?: Maybe<IChannelData>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  item?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IChannelResponseV2 = {
  avatar?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isChannelLive?: Maybe<Scalars['String']>;
  ivsChannelName?: Maybe<Scalars['String']>;
  liveUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  followerCount?: Maybe<Scalars['String']>;
};

export type IChat = {
  eventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<IMessage>>>;
};

export type IChatDataInput = {
  id?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<IChatDataUserInput>;
  pin?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
};

export type IChatDataResponse = {
  color?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  user?: Maybe<IChatDataUserResponse>;
};

export type IChatDataUserInput = {
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type IChatDataUserResponse = {
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type IChatInput = {
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<IMessageInput>>>;
};

export type IChatPayload = {
  eventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<IMessage>;
};

export type ICheckPpvVisitResponse = {
  alreadyVisitedByIp?: Maybe<Scalars['Boolean']>;
  alreadyVisitedByUser?: Maybe<Scalars['Boolean']>;
  isAllowed?: Maybe<Scalars['Boolean']>;
};

export type ICheckPayload = {
  isTaken?: Maybe<Scalars['Boolean']>;
};

export type ICheckUserByEmail = {
  email?: InputMaybe<Scalars['String']>;
};

export type ICheckUserByUserName = {
  username?: InputMaybe<Scalars['String']>;
};

export type IConfirmSignUpPayload = {
  confirmationCode: Scalars['String'];
  username: Scalars['String'];
};

export type ICreateAuthorizationInput = {
  authState?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ICreateCategoryInput = {
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type ICreateChannelInput = {
  banner?: InputMaybe<Scalars['String']>;
  channelArn?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imagen?: InputMaybe<Scalars['String']>;
  ingestServer?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  streamKey?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  watermark?: InputMaybe<Scalars['String']>;
};

export type ICreateEventDataResponse = {
  event?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type ICreateEventForChannelAsDraftInput = {
  channelId: Scalars['String'];
  details?: InputMaybe<IDetailsAsDraft>;
  monetization?: InputMaybe<IMonetizationAsDraft>;
  options?: InputMaybe<IOptionsAsDraft>;
  streamers?: InputMaybe<Array<InputMaybe<IStreamersAsDraft>>>;
};

export type ICreateEventForChannelAsDraftInputV2 = {
  channelId: Scalars['String'];
  details?: InputMaybe<IDetailsAsDraftV2>;
  monetization?: InputMaybe<IMonetizationAsDraftV2>;
  options?: InputMaybe<IOptionsAsDraftV2>;
  streamers?: InputMaybe<Array<InputMaybe<IStreamersAsDraftV2>>>;
};

export type ICreateEventForChannelInput = {
  channelId: Scalars['String'];
  details: IDetails;
  monetization: IMonetization;
  options: IOptions;
  streamers: Array<InputMaybe<IStreamers>>;
};

export type ICreateEventInput = {
  address?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  chats?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endTime?: InputMaybe<Scalars['String']>;
  ended?: InputMaybe<Scalars['Boolean']>;
  eventDate?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventTime?: InputMaybe<Scalars['String']>;
  eventTimezone?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  imgDescription?: InputMaybe<Scalars['String']>;
  organizer?: InputMaybe<Scalars['String']>;
  paidEvent?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  priceId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sponsorLogos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sponsors?: InputMaybe<Array<InputMaybe<ISponsorInput>>>;
  startTime?: InputMaybe<Scalars['String']>;
  streamData?: InputMaybe<Array<InputMaybe<IStreamInput>>>;
  streamingFrom?: InputMaybe<Scalars['String']>;
  subHeading?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalStreamViews?: InputMaybe<Scalars['Int']>;
  totalViews?: InputMaybe<Scalars['Int']>;
  viewedUser?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  viewers?: InputMaybe<Scalars['Int']>;
};

export type ICreateEventResponse = {
  data?: Maybe<ICreateEventDataResponse>;
  error?: Maybe<Scalars['String']>;
};

export type ICreateEventTypeInput = {
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ICreateLivestreamingInput = {
  autoRecord?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  forChilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ICreatePaymentIntentInput = {
  eventId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ICreateRoleInput = {
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roleState?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ICreateTransactionInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  img?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  receipt_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ICreateUserInput = {
  avatar?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type ICreateVideoInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  forChilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['String']>;
  recordingSessionId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnail?: InputMaybe<Scalars['String']>;
  thumbnailsPath?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ICredentialsLivestreaming = {
  channelArn?: Maybe<Scalars['String']>;
  ingestServer?: Maybe<Scalars['String']>;
  playbackUrl?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
};

export type ICredentialsLivestreamingPayload = {
  credentialsLivestreaming?: Maybe<ICredentialsLivestreaming>;
  error?: Maybe<Scalars['String']>;
};

export type IDeletePayload = {
  data?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type IDetails = {
  duration: Scalars['Int'];
  eventCategory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventDescription: Scalars['String'];
  eventName: Scalars['String'];
  eventOwner?: InputMaybe<Scalars['String']>;
  eventPosterImage?: InputMaybe<Scalars['String']>;
  eventStartDateAndTime: Scalars['String'];
  eventThumbnail?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
};

export type IDetailsAsDraft = {
  duration?: InputMaybe<Scalars['Int']>;
  eventCategory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventName: Scalars['String'];
  eventOwner?: InputMaybe<Scalars['String']>;
  eventPosterImage?: InputMaybe<Scalars['String']>;
  eventStartDateAndTime?: InputMaybe<Scalars['String']>;
  eventThumbnail?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
};

export type IDetailsAsDraftV2 = {
  duration?: InputMaybe<Scalars['Int']>;
  eventCategory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventName: Scalars['String'];
  eventOwner?: InputMaybe<Scalars['String']>;
  eventPosterImage?: InputMaybe<Scalars['String']>;
  eventStartDateAndTime?: InputMaybe<Scalars['String']>;
  eventThumbnail?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
};

export type IDetailsResponse = {
  duration?: Maybe<Scalars['Int']>;
  eventCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventDescription?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  eventOwner?: Maybe<Scalars['String']>;
  eventPosterImage?: Maybe<Scalars['String']>;
  eventStartDateAndTime?: Maybe<Scalars['String']>;
  eventThumbnail?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
};

export type IDetailsResponseV2 = {
  duration?: Maybe<Scalars['Int']>;
  eventCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventDescription?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  eventOwner?: Maybe<Scalars['String']>;
  eventPosterImage?: Maybe<Scalars['String']>;
  eventStartDateAndTime?: Maybe<Scalars['String']>;
  eventThumbnail?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
};

export type IEditEventInputV2 = {
  channelId: Scalars['String'];
  details?: InputMaybe<IDetailsAsDraftV2>;
  id: Scalars['String'];
  monetization?: InputMaybe<IMonetizationAsDraftV2>;
  options?: InputMaybe<IOptionsAsDraftV2>;
  streamers?: InputMaybe<Array<InputMaybe<IStreamersAsDraftEditV2>>>;
};

export type IEditEventResponse = {
  data?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type IEditMediaInput = {
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mediaId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type IEmailInvite = {
  customMessage?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  isPrivateMessage: Scalars['Boolean'];
};

export type IEmailInviteAsDraft = {
  customMessage?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  isPrivateMessage?: InputMaybe<Scalars['Boolean']>;
};

export type IEmailInviteResponse = {
  customMessage?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isPrivateMessage?: Maybe<Scalars['Boolean']>;
};

export type IEmailInviteResponseV2 = {
  customMessage?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isPrivateMessage?: Maybe<Scalars['Boolean']>;
};

export type IEmbedStreams = {
  chat: Array<InputMaybe<IStreamersChat>>;
  logo?: InputMaybe<Scalars['String']>;
  streamName: Scalars['String'];
  streamType: Scalars['String'];
  streamUrl: Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IEmbedStreamsAsDraft = {
  chat?: InputMaybe<Array<InputMaybe<IStreamersChatAsDraft>>>;
  logo?: InputMaybe<Scalars['String']>;
  streamName?: InputMaybe<Scalars['String']>;
  streamType?: InputMaybe<Scalars['String']>;
  streamUrl?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IEmbedStreamsAsDraftV2 = {
  chat?: InputMaybe<Array<InputMaybe<IStreamersChatAsDraftV2>>>;
  logo?: InputMaybe<Scalars['String']>;
  streamName?: InputMaybe<Scalars['String']>;
  streamType?: InputMaybe<Scalars['String']>;
  streamUrl?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IEmbedStreamsResponse = {
  chat?: Maybe<Array<Maybe<IStreamersChatResponse>>>;
  logo?: Maybe<Scalars['String']>;
  streamName?: Maybe<Scalars['String']>;
  streamType?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IEmbedStreamsResponseV2 = {
  chat?: Maybe<Array<Maybe<IStreamersChatResponseV2>>>;
  logo?: Maybe<Scalars['String']>;
  streamName?: Maybe<Scalars['String']>;
  streamType?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IEntityViewResponse = {
  current?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type IEvent = {
  address?: Maybe<Scalars['String']>;
  category?: Maybe<Array<Maybe<Scalars['String']>>>;
  chats?: Maybe<Array<Maybe<Scalars['String']>>>;
  endTime?: Maybe<Scalars['String']>;
  ended?: Maybe<Scalars['Boolean']>;
  eventDate?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventTime?: Maybe<Scalars['String']>;
  eventTimezone?: Maybe<Scalars['String']>;
  eventType?: Maybe<Array<Maybe<Scalars['String']>>>;
  featuredImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  imgDescription?: Maybe<Scalars['String']>;
  organizer?: Maybe<Scalars['String']>;
  paidEvent?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  priceId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  sponsorLogos?: Maybe<Array<Maybe<Scalars['String']>>>;
  sponsors?: Maybe<Array<Maybe<ISponsor>>>;
  startTime?: Maybe<Scalars['String']>;
  streamData?: Maybe<Array<Maybe<IStream>>>;
  streamingFrom?: Maybe<Scalars['String']>;
  subHeading?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalStreamViews?: Maybe<Scalars['Int']>;
  totalViews?: Maybe<Scalars['Int']>;
  viewedUser?: Maybe<Array<Maybe<Scalars['String']>>>;
  viewers?: Maybe<Scalars['Int']>;
};

export enum IEventActionType {
  Archive = 'ARCHIVE',
  Finish = 'FINISH',
  Remove = 'REMOVE',
  Start = 'START',
}

export type IEventCategoryData = {
  createdAt?: Maybe<Scalars['String']>;
  eventCategory?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IEventCategoryPayload = {
  error?: Maybe<Scalars['String']>;
  eventCategory?: Maybe<IEventCategoryData>;
};

export type IEventChatMessageSentResponse = {
  data?: Maybe<IChatDataResponse>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
};

export type IEventChatMessagesResponse = {
  messages?: Maybe<Array<Maybe<IChatDataResponse>>>;
};

export type IEventChatResponse = {
  error?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<IChatDataResponse>>>;
};

export type IEventData = {
  createdAt?: Maybe<Scalars['String']>;
  eventData?: Maybe<IEvent>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IEventDataResponse = {
  eventData?: Maybe<IEventViewsDetails>;
};

export type IEventDataViewersResponse = {
  eventData?: Maybe<IEventViewersDetails>;
};

export type IEventPayload = {
  error?: Maybe<Scalars['String']>;
  event?: Maybe<IEventData>;
};

export type IEventResponse = {
  slug: any;
  attendees?: Maybe<Array<Maybe<IAttendeeType>>>;
  availableActions?: Maybe<IAvailableActionsType>;
  createdAt?: Maybe<Scalars['String']>;
  details?: Maybe<IDetailsResponse>;
  id?: Maybe<Scalars['String']>;
  monetization?: Maybe<IMonetizationResponse>;
  options?: Maybe<IOptionsResponse>;
  status?: Maybe<IStatusType>;
  streamers?: Maybe<Array<Maybe<IStreamersResponse>>>;
};

export type IEventTypeData = {
  createdAt?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IEventTypePayload = {
  error?: Maybe<Scalars['String']>;
  eventType?: Maybe<IEventTypeData>;
};

export type IEventTypeResponseV2 = {
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type IEventViewersDetails = {
  viewers?: Maybe<Scalars['Int']>;
};

export type IEventViewsDetails = {
  totalViews?: Maybe<Scalars['Int']>;
};

export type IFeaturedEvent = {
  eventId?: Maybe<Scalars['String']>;
  stream?: Maybe<IStream>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IFeaturedEventData = {
  event?: Maybe<IEventData>;
  stream?: Maybe<IStream>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IFeaturedEventInput = {
  eventId?: InputMaybe<Scalars['String']>;
  stream?: InputMaybe<IStreamInput>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IFileInput = {
  src?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type IGetAboutpagePayload = {
  aboutFeatures?: Maybe<Array<Maybe<IAboutFeatureData>>>;
  details?: Maybe<IAboutDetailsData>;
  error?: Maybe<Scalars['String']>;
  testimonials?: Maybe<Array<Maybe<ITestimonialData>>>;
  trustedBy?: Maybe<Array<Maybe<ITrustedByData>>>;
  upcomingEvents?: Maybe<Array<Maybe<IUpcomingEventData>>>;
};

export type IGetCarouselDataResponse = {
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  viewers?: Maybe<IEntityViewResponse>;
};

export type IGetCurrentLiveStreamResponse = {
  isStreamLive?: Maybe<Scalars['Boolean']>;
  liveVodUrl?: Maybe<Scalars['String']>;
  offline?: Maybe<Scalars['Boolean']>;
  playbackUrl?: Maybe<Scalars['String']>;
  vodUrl?: Maybe<Scalars['String']>;
};

export type IGetEventByIdResponse = {
  error?: Maybe<Scalars['String']>;
  event?: Maybe<IEventResponse>;
};

export type IGetEventsForCarouselV2 = {
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  posterImage?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  viewers?: Maybe<IEntityViewResponse>;
};

export type IGetHomepageVideosPayload = {
  error?: Maybe<Scalars['String']>;
  featuredEvents?: Maybe<Array<Maybe<IFeaturedEventData>>>;
  recentVods?: Maybe<Array<Maybe<IFeaturedEventData>>>;
  showcaseEvents?: Maybe<Array<Maybe<IShowcaseEventData>>>;
};

export type IGetLandingVideos = {
  error?: Maybe<Scalars['String']>;
  featuredEvents?: Maybe<Array<Maybe<IEventResponse>>>;
  liveEvents?: Maybe<Array<Maybe<IEventResponse>>>;
  scheduledEvents?: Maybe<Array<Maybe<IEventResponse>>>;
};

export type IGetPresignedUploadUrlResponseV2 = {
  url: Scalars['String'];
};

export type IGetSignedUrlResponseV2 = {
  url: Scalars['String'];
};

export type IGetStreamInput = {
  channelId: Scalars['String'];
  mediaId?: InputMaybe<Scalars['String']>;
};

export type IGetThumbnailResponse = {
  url?: Maybe<Scalars['String']>;
};

export type IGetUserVenuesResponseV2 = {
  description: Scalars['String'];
  facebookUrl: Scalars['String'];
  id: Scalars['String'];
  instagramUrl: Scalars['String'];
  isDirty: Scalars['Boolean'];
  name: Scalars['String'];
  tikTokUrl: Scalars['String'];
  twitchUrl: Scalars['String'];
  twitterUrl: Scalars['String'];
  user?: Maybe<IUserSimpleResponseV2>;
  userId: Scalars['String'];
  websiteUrl: Scalars['String'];
};

export type IGlobalSignOutResponse = {
  body?: Maybe<Scalars['String']>;
};

export type IHomepageVideosPayload = {
  error?: Maybe<Scalars['String']>;
  video?: Maybe<IVideoData>;
};

export type IIsTakenResponseV2 = {
  isTaken?: Maybe<Scalars['Boolean']>;
};

export type IKlic = {
  channel: Scalars['String'];
  chat: Array<InputMaybe<IStreamersChat>>;
  isThumbnailOverridden?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type IKlicAsDraft = {
  channel?: InputMaybe<Scalars['String']>;
  chat?: InputMaybe<Array<InputMaybe<IStreamersChat>>>;
  isThumbnailOverridden?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type IKlicAsDraftV2 = {
  channel?: InputMaybe<Scalars['String']>;
  chat?: InputMaybe<Array<InputMaybe<IStreamersChatV2>>>;
  isThumbnailOverridden?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type IKlicChatMessageSentResponse = {
  channel?: Maybe<Scalars['String']>;
  data?: Maybe<IChatDataResponse>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
};

export type IKlicChatMessagesResponse = {
  channel?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<IChatDataResponse>>>;
};

export type IKlicChatResponse = {
  channel?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<IChatDataResponse>>>;
};

export type IKlicResponse = {
  channel?: Maybe<IChannelResponse>;
  chat?: Maybe<Array<Maybe<IStreamersChatResponse>>>;
  isThumbnailOverridden?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type IKlicResponseV2 = {
  channel?: Maybe<ISimpleChannelResponseV2>;
  chat?: Maybe<Array<Maybe<IStreamersChatResponseV2>>>;
  isThumbnailOverridden?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  mediaOffset?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  vodUrl?: Maybe<Scalars['String']>;
};

export type ILandingResponseV2 = {
  carouselData?: Maybe<Array<Maybe<IGetCarouselDataResponse>>>;
  featuredEvents?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
  liveEvents?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
  recordedEvents?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
  scheduledEvents?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
};

export type IListAllChannelsResponse = {
  channels?: Maybe<Array<Maybe<IChannelResponse>>>;
  error?: Maybe<Scalars['String']>;
};

export type IListAllEventsResponse = {
  error?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<IEventResponse>>>;
};

export type IListAllEventsResponseV2 = {
  events?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
};

export type IListAuthorizationsPayload = {
  authorizations?: Maybe<Array<Maybe<IAuthorization>>>;
  error?: Maybe<Scalars['String']>;
};

export type IListEventCategoriesPayload = {
  error?: Maybe<Scalars['String']>;
  eventCategories?: Maybe<Array<Maybe<IEventCategoryData>>>;
};

export type IListEventTypesPayload = {
  error?: Maybe<Scalars['String']>;
  eventTypes?: Maybe<Array<Maybe<IEventTypeData>>>;
};

export type IListEventsPayload = {
  error?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<IEventData>>>;
};

export type IListLivestreamingPayload = {
  error?: Maybe<Scalars['String']>;
  livestreamings?: Maybe<Array<Maybe<ILivestreaming>>>;
};

export type IListRolesPayload = {
  error?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<IRole>>>;
};

export type IListTransactionsPayload = {
  error?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<ITransaction>>>;
};

export type IListTransactionsUserPayload = {
  error?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<ITransactionUser>>>;
};

export type IListVideosPayload = {
  error?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<IVideo>>>;
};

export type ILivestreaming = {
  autoRecord?: Maybe<Scalars['Boolean']>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  forChilds?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  playbackUrl?: Maybe<Scalars['String']>;
  privacy?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ILivestreamingPayload = {
  error?: Maybe<Scalars['String']>;
  livestreaming?: Maybe<ILivestreaming>;
};

export type IMessage = {
  date?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userImg?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type IMessageChatInput = {
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<IMessageInput>;
};

export type IMessageInput = {
  date?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userImg?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type IMessagePayload = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<IChatPayload>;
};

export type IModifiedSponsorInput = {
  sponsorImage?: InputMaybe<IFileInput>;
  sponsorName?: InputMaybe<Scalars['String']>;
  sponsorUrl?: InputMaybe<Scalars['String']>;
};

export type IMonetization = {
  adFrequency?: InputMaybe<Scalars['Int']>;
  adLength?: InputMaybe<Scalars['Int']>;
  allowFreePreview: Scalars['Boolean'];
  allowFreePreviewSub: Scalars['Boolean'];
  allowNonSubscribersPPV: Scalars['Boolean'];
  allowPPVSub: Scalars['Boolean'];
  contributorsOptions?: InputMaybe<Scalars['String']>;
  freePreviewTime?: InputMaybe<Scalars['String']>;
  freePreviewTimeSub?: InputMaybe<Scalars['String']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  messageForViewers?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  monetizationType?: InputMaybe<IMonetizationType>;
  preRoll: Scalars['Boolean'];
  price1?: InputMaybe<Scalars['String']>;
  price2?: InputMaybe<Scalars['String']>;
  price3?: InputMaybe<Scalars['String']>;
  price4?: InputMaybe<Scalars['String']>;
  priceInput?: InputMaybe<IPriceInputType>;
  pricePerPPV?: InputMaybe<Scalars['String']>;
  pricePerPPVSub?: InputMaybe<Scalars['String']>;
  sponsor: Array<InputMaybe<IMonetizationSponsor>>;
  subscribersOnly: Scalars['Boolean'];
};

export type IMonetizationAsDraft = {
  adFrequency?: InputMaybe<Scalars['Int']>;
  adLength?: InputMaybe<Scalars['Int']>;
  allowFreePreview?: InputMaybe<Scalars['Boolean']>;
  allowFreePreviewSub?: InputMaybe<Scalars['Boolean']>;
  allowNonSubscribersPPV?: InputMaybe<Scalars['Boolean']>;
  allowPPVSub?: InputMaybe<Scalars['Boolean']>;
  contributorsOptions?: InputMaybe<Scalars['String']>;
  freePreviewTime?: InputMaybe<Scalars['String']>;
  freePreviewTimeSub?: InputMaybe<Scalars['String']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  messageForViewers?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  monetizationType?: InputMaybe<IMonetizationType>;
  preRoll?: InputMaybe<Scalars['Boolean']>;
  price1?: InputMaybe<Scalars['String']>;
  price2?: InputMaybe<Scalars['String']>;
  price3?: InputMaybe<Scalars['String']>;
  price4?: InputMaybe<Scalars['String']>;
  priceInput?: InputMaybe<IPriceInputType>;
  pricePerPPV?: InputMaybe<Scalars['String']>;
  pricePerPPVSub?: InputMaybe<Scalars['String']>;
  sponsor: Array<InputMaybe<IMonetizationSponsor>>;
  subscribersOnly?: InputMaybe<Scalars['Boolean']>;
};

export type IMonetizationAsDraftV2 = {
  adFrequency?: InputMaybe<Scalars['Int']>;
  adLength?: InputMaybe<Scalars['Int']>;
  allowFreePreview?: InputMaybe<Scalars['Boolean']>;
  allowFreePreviewSub?: InputMaybe<Scalars['Boolean']>;
  allowNonSubscribersPPV?: InputMaybe<Scalars['Boolean']>;
  allowPPVSub?: InputMaybe<Scalars['Boolean']>;
  contributorsOptions?: InputMaybe<Scalars['String']>;
  freePreviewTime?: InputMaybe<Scalars['String']>;
  freePreviewTimeSub?: InputMaybe<Scalars['String']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  messageForViewers?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  monetizationType?: InputMaybe<IMonetizationTypeV2>;
  preRoll?: InputMaybe<Scalars['Boolean']>;
  price1?: InputMaybe<Scalars['String']>;
  price2?: InputMaybe<Scalars['String']>;
  price3?: InputMaybe<Scalars['String']>;
  price4?: InputMaybe<Scalars['String']>;
  priceInput?: InputMaybe<IPriceInputTypeV2>;
  pricePerPPV?: InputMaybe<Scalars['String']>;
  pricePerPPVSub?: InputMaybe<Scalars['String']>;
  sponsor: Array<InputMaybe<IMonetizationSponsorV2>>;
  subscribersOnly?: InputMaybe<Scalars['Boolean']>;
};

export type IMonetizationResponse = {
  adFrequency?: Maybe<Scalars['Int']>;
  adLength?: Maybe<Scalars['Int']>;
  allowFreePreview?: Maybe<Scalars['Boolean']>;
  allowFreePreviewSub?: Maybe<Scalars['Boolean']>;
  allowNonSubscribersPPV?: Maybe<Scalars['Boolean']>;
  allowPPVSub?: Maybe<Scalars['Boolean']>;
  contributorsOptions?: Maybe<Scalars['String']>;
  freePreviewTime?: Maybe<Scalars['String']>;
  freePreviewTimeSub?: Maybe<Scalars['String']>;
  maxPrice?: Maybe<Scalars['String']>;
  messageForViewers?: Maybe<Scalars['String']>;
  minPrice?: Maybe<Scalars['String']>;
  monetizationType?: Maybe<IMonetizationType>;
  preRoll?: Maybe<Scalars['Boolean']>;
  price1?: Maybe<Scalars['String']>;
  price2?: Maybe<Scalars['String']>;
  price3?: Maybe<Scalars['String']>;
  price4?: Maybe<Scalars['String']>;
  priceInput?: Maybe<IPriceInputType>;
  pricePerPPV?: Maybe<Scalars['String']>;
  pricePerPPVSub?: Maybe<Scalars['String']>;
  sponsor?: Maybe<Array<Maybe<IMonetizationSponsorResponse>>>;
  subscribersOnly?: Maybe<Scalars['Boolean']>;
};

export type IMonetizationResponseV2 = {
  adFrequency?: Maybe<Scalars['Int']>;
  adLength?: Maybe<Scalars['Int']>;
  allowFreePreview?: Maybe<Scalars['Boolean']>;
  allowFreePreviewSub?: Maybe<Scalars['Boolean']>;
  allowNonSubscribersPPV?: Maybe<Scalars['Boolean']>;
  allowPPVSub?: Maybe<Scalars['Boolean']>;
  contributorsOptions?: Maybe<Scalars['String']>;
  freePreviewTime?: Maybe<Scalars['String']>;
  freePreviewTimeSub?: Maybe<Scalars['String']>;
  maxPrice?: Maybe<Scalars['String']>;
  messageForViewers?: Maybe<Scalars['String']>;
  minPrice?: Maybe<Scalars['String']>;
  monetizationType?: Maybe<IMonetizationTypeV2>;
  preRoll?: Maybe<Scalars['Boolean']>;
  price1?: Maybe<Scalars['String']>;
  price2?: Maybe<Scalars['String']>;
  price3?: Maybe<Scalars['String']>;
  price4?: Maybe<Scalars['String']>;
  priceInput?: Maybe<IPriceInputTypeV2>;
  pricePerPPV?: Maybe<Scalars['String']>;
  pricePerPPVSub?: Maybe<Scalars['String']>;
  sponsor?: Maybe<Array<Maybe<IMonetizationSponsorResponseV2>>>;
  subscribersOnly?: Maybe<Scalars['Boolean']>;
};

export type IMonetizationSponsor = {
  sponsorAmount?: InputMaybe<Scalars['String']>;
  sponsorLogo?: InputMaybe<Scalars['String']>;
  sponsorName: Scalars['String'];
};

export type IMonetizationSponsorAsDraft = {
  sponsorAmount?: InputMaybe<Scalars['String']>;
  sponsorLogo?: InputMaybe<Scalars['String']>;
  sponsorName: Scalars['String'];
};

export type IMonetizationSponsorResponse = {
  sponsorAmount?: Maybe<Scalars['String']>;
  sponsorLogo?: Maybe<Scalars['String']>;
  sponsorName?: Maybe<Scalars['String']>;
};

export type IMonetizationSponsorResponseV2 = {
  sponsorAmount?: Maybe<Scalars['String']>;
  sponsorLogo?: Maybe<Scalars['String']>;
  sponsorName?: Maybe<Scalars['String']>;
};

export type IMonetizationSponsorV2 = {
  sponsorAmount?: InputMaybe<Scalars['String']>;
  sponsorLogo?: InputMaybe<Scalars['String']>;
  sponsorName: Scalars['String'];
};

export enum IMonetizationType {
  Advertisements = 'advertisements',
  Contributors = 'contributors',
  PayPerView = 'payPerView',
}

export enum IMonetizationTypeV2 {
  Advertisements = 'advertisements',
  Contributors = 'contributors',
  PayPerView = 'payPerView',
}

export type IMutation = {
  addLiveViewV2?: Maybe<IEntityViewResponse>;
  archiveEvent?: Maybe<IEditEventResponse>;
  attendEvent?: Maybe<IAttendEventResponse>;
  attendEventV2?: Maybe<IAttendEventResponse>;
  checkUserByEmail?: Maybe<ICheckPayload>;
  checkUserByUserName?: Maybe<ICheckPayload>;
  confirmSignUp?: Maybe<Scalars['String']>;
  createAuthorization?: Maybe<IAuthorizationPayload>;
  createCategoryV2?: Maybe<ICategoryResponseV2>;
  createEvent?: Maybe<IEventPayload>;
  createEventCategory?: Maybe<IEventCategoryPayload>;
  createEventForChannel?: Maybe<ICreateEventResponse>;
  createEventForChannelAsDraft?: Maybe<ICreateEventResponse>;
  createEventForChannelV2?: Maybe<Scalars['String']>;
  createEventType?: Maybe<IEventTypePayload>;
  createEventTypeV2?: Maybe<IEventTypeResponseV2>;
  createEventV2?: Maybe<ICreateEventResponse>;
  createLivestreaming?: Maybe<ILivestreamingPayload>;
  createPaymentIntent?: Maybe<IPaymentIntentPayload>;
  createRole?: Maybe<IRolePayload>;
  createTransaction?: Maybe<ITransactionPayload>;
  createUser?: Maybe<IUserPayload>;
  createVenueLegacy?: Maybe<Scalars['String']>;
  createVideo?: Maybe<IVideoPayload>;
  createVisitEvent?: Maybe<Scalars['String']>;
  deleteAuthorization?: Maybe<IDeletePayload>;
  deleteEvent?: Maybe<IDeletePayload>;
  deleteEventCategory?: Maybe<IDeletePayload>;
  deleteEventType?: Maybe<IDeletePayload>;
  editEvent?: Maybe<IEditEventResponse>;
  editEventV2?: Maybe<Scalars['String']>;
  editMediaV2?: Maybe<IStreamResponseV2>;
  enableAndDisableRecording?: Maybe<Scalars['Boolean']>;
  eventActionsV2?: Maybe<Scalars['String']>;
  finishEvent?: Maybe<IEditEventResponse>;
  gfxImageProcessor?: Maybe<IGetPresignedUploadUrlResponseV2>;
  globalSignOutV2?: Maybe<IGlobalSignOutResponse>;
  migrateEventCategories?: Maybe<IEditEventResponse>;
  removeEvent?: Maybe<IRemoveEventResponse>;
  removeLiveViewV2?: Maybe<IEntityViewResponse>;
  sendMessageChatKlic?: Maybe<IMessagePayload>;
  sendMessageEventChat?: Maybe<IEventChatMessageSentResponse>;
  sendMessageEventChatV2?: Maybe<ISendMessageEventChatResponse>;
  sendMessageKlicChat?: Maybe<IKlicChatMessageSentResponse>;
  sendMessageKlicChatV2?: Maybe<ISendMessageKlicChatResponse>;
  signUp?: Maybe<Scalars['String']>;
  startEvent?: Maybe<IEditEventResponse>;
  startStreamerByAdmin?: Maybe<IStreamersResponseV2>;
  stopStreamerByAdmin?: Maybe<IStreamersResponseV2>;
  updateAboutpage?: Maybe<IAboutPayload>;
  updateAuthorization?: Maybe<IAuthorizationPayload>;
  updateCategoryV2?: Maybe<ICategoryResponseV2>;
  updateChannel?: Maybe<IChannelPayload>;
  updateEvent?: Maybe<IEventPayload>;
  updateEventCategory?: Maybe<IEventCategoryPayload>;
  updateEventType?: Maybe<IEventTypePayload>;
  updateEventTypeV2?: Maybe<IEventTypeResponseV2>;
  updateEventViewers?: Maybe<IUpdateEventViewersResponse>;
  updateEventViews?: Maybe<IUpdateEventViewsResponse>;
  updateHomepageVideos?: Maybe<IHomepageVideosPayload>;
  updateLivestreaming?: Maybe<ILivestreamingPayload>;
  updateUserProfile?: Maybe<IUserPayload>;
  updateUserProfileV2?: Maybe<IUpdateUserProfileResponseV2>;
  updateVenue?: Maybe<IUpdateVenueResponseV2>;
  updateVideo?: Maybe<IVideoPayload>;
};

export type IMutationAddLiveViewV2Args = {
  id: Scalars['String'];
  type: Scalars['String'];
};

export type IMutationArchiveEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationAttendEventArgs = {
  eventId?: InputMaybe<Scalars['String']>;
  userData?: InputMaybe<IUserDataInput>;
};

export type IMutationAttendEventV2Args = {
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type IMutationCheckUserByEmailArgs = {
  checkUserByEmailRequest?: InputMaybe<ICheckUserByEmail>;
};

export type IMutationCheckUserByUserNameArgs = {
  checkUserByUserNameRequest?: InputMaybe<ICheckUserByUserName>;
};

export type IMutationConfirmSignUpArgs = {
  confirmSignUpPayload?: InputMaybe<IConfirmSignUpPayload>;
};

export type IMutationCreateAuthorizationArgs = {
  createAuthorizationPayload?: InputMaybe<ICreateAuthorizationInput>;
};

export type IMutationCreateCategoryV2Args = {
  createCategoryInput?: InputMaybe<ICreateCategoryInput>;
};

export type IMutationCreateEventArgs = {
  createEventPayload?: InputMaybe<ICreateEventInput>;
};

export type IMutationCreateEventCategoryArgs = {
  eventCategory?: InputMaybe<Scalars['String']>;
};

export type IMutationCreateEventForChannelArgs = {
  createEventForChannelRequest?: InputMaybe<ICreateEventForChannelInput>;
};

export type IMutationCreateEventForChannelAsDraftArgs = {
  createEventForChannelAsDraftRequest?: InputMaybe<ICreateEventForChannelAsDraftInput>;
};

export type IMutationCreateEventForChannelV2Args = {
  createEventInput?: InputMaybe<ICreateEventForChannelAsDraftInputV2>;
};

export type IMutationCreateEventTypeArgs = {
  eventType?: InputMaybe<Scalars['String']>;
};

export type IMutationCreateEventTypeV2Args = {
  createEventTypeInput?: InputMaybe<ICreateEventTypeInput>;
};

export type IMutationCreateEventV2Args = {
  createEventForChannelAsDraftRequest?: InputMaybe<ICreateEventForChannelAsDraftInput>;
};

export type IMutationCreateLivestreamingArgs = {
  createLivestreamingPayload?: InputMaybe<ICreateLivestreamingInput>;
};

export type IMutationCreatePaymentIntentArgs = {
  createPaymentIntentPayload?: InputMaybe<ICreatePaymentIntentInput>;
};

export type IMutationCreateRoleArgs = {
  createRolePayload?: InputMaybe<ICreateRoleInput>;
};

export type IMutationCreateTransactionArgs = {
  createTransactionPayload?: InputMaybe<ICreateTransactionInput>;
};

export type IMutationCreateUserArgs = {
  createUserPayload?: InputMaybe<ICreateUserInput>;
};

export type IMutationCreateVenueLegacyArgs = {
  userId?: InputMaybe<Scalars['String']>;
};

export type IMutationCreateVideoArgs = {
  createVideoPayload?: InputMaybe<ICreateVideoInput>;
};

export type IMutationCreateVisitEventArgs = {
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type IMutationDeleteAuthorizationArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationDeleteEventArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationDeleteEventCategoryArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationDeleteEventTypeArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationEditEventArgs = {
  editEventRequest?: InputMaybe<ICreateEventForChannelAsDraftInput>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationEditEventV2Args = {
  editEventInput?: InputMaybe<IEditEventInputV2>;
};

export type IMutationEditMediaV2Args = {
  editMediaInput?: InputMaybe<IEditMediaInput>;
};

export type IMutationEnableAndDisableRecordingArgs = {
  activate?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationEventActionsV2Args = {
  action: IEventActionType;
  eventId: Scalars['String'];
};

export type IMutationFinishEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationGetPresignedUploadUrlV2Args = {
  key: Scalars['String'];
  type: Scalars['String'];
};

export type IMutationGlobalSignOutV2Args = {
  username: Scalars['String'];
};

export type IMutationRemoveEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationRemoveLiveViewV2Args = {
  id: Scalars['String'];
  type: Scalars['String'];
};

export type IMutationSendMessageChatKlicArgs = {
  messagePayload?: InputMaybe<IMessageChatInput>;
};

export type IMutationSendMessageEventChatArgs = {
  chatData?: InputMaybe<IChatDataInput>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationSendMessageEventChatV2Args = {
  chatData: IChatDataInput;
  eventId: Scalars['String'];
};

export type IMutationSendMessageKlicChatArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  chatData?: InputMaybe<IChatDataInput>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationSendMessageKlicChatV2Args = {
  channelId: Scalars['String'];
  chatData: IChatDataInput;
  eventId: Scalars['String'];
};

export type IMutationSignUpArgs = {
  signUpPayload?: InputMaybe<ISignupPayload>;
};

export type IMutationStartEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationStartStreamerByAdminArgs = {
  streamerId: Scalars['String'];
};

export type IMutationStopStreamerByAdminArgs = {
  streamerId: Scalars['String'];
};

export type IMutationUpdateAboutpageArgs = {
  aboutPayload?: InputMaybe<IUpdateAboutpageInput>;
};

export type IMutationUpdateAuthorizationArgs = {
  updateAuthorizationPayload?: InputMaybe<IUpdateAuthorizationInput>;
};

export type IMutationUpdateCategoryV2Args = {
  updateCategoryInput?: InputMaybe<IUpdateCategoryInput>;
};

export type IMutationUpdateChannelArgs = {
  updateChannelPayload?: InputMaybe<IUpdateChannelInput>;
};

export type IMutationUpdateEventArgs = {
  updateEventPayload?: InputMaybe<IUpdateEventInput>;
};

export type IMutationUpdateEventCategoryArgs = {
  updateEventCategoryPayload?: InputMaybe<IUpdateEventCategoryInput>;
};

export type IMutationUpdateEventTypeArgs = {
  updateEventTypePayload?: InputMaybe<IUpdateEventTypeInput>;
};

export type IMutationUpdateEventTypeV2Args = {
  updateEventTypeInput?: InputMaybe<IUpdateEventTypeInput>;
};

export type IMutationUpdateEventViewersArgs = {
  id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type IMutationUpdateEventViewsArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationUpdateHomepageVideosArgs = {
  updateHomepageVideosPayload?: InputMaybe<IUpdateHomepageVideosInput>;
};

export type IMutationUpdateLivestreamingArgs = {
  updateLivestreamingPayload?: InputMaybe<IUpdateLivestreamingInput>;
};

export type IMutationUpdateUserProfileArgs = {
  updateUserPayload?: InputMaybe<IUpdateUserInput>;
};

export type IMutationUpdateUserProfileV2Args = {
  updateUserProfileInput?: InputMaybe<IUpdateUserProfileInput>;
};

export type IMutationUpdateVenueArgs = {
  updateVenueInput?: InputMaybe<IUpdateVenueInput>;
};

export type IMutationUpdateVideoArgs = {
  updateVideoPayload?: InputMaybe<IUpdateVideoInput>;
};

export type IOptions = {
  allowOtherChats: Scalars['Boolean'];
  isPrivateEvent: Scalars['Boolean'];
  numberOfChatsPerStream?: InputMaybe<Scalars['Int']>;
  privateEventPassword?: InputMaybe<Scalars['String']>;
  recordEvent: Scalars['Boolean'];
  recordEventExpirationDate?: InputMaybe<Scalars['String']>;
};

export type IOptionsAsDraft = {
  allowOtherChats?: InputMaybe<Scalars['Boolean']>;
  isPrivateEvent?: InputMaybe<Scalars['Boolean']>;
  numberOfChatsPerStream?: InputMaybe<Scalars['Int']>;
  privateEventPassword?: InputMaybe<Scalars['String']>;
  recordEvent?: InputMaybe<Scalars['Boolean']>;
  recordEventExpirationDate?: InputMaybe<Scalars['String']>;
};

export type IOptionsAsDraftV2 = {
  allowOtherChats?: InputMaybe<Scalars['Boolean']>;
  isPrivateEvent?: InputMaybe<Scalars['Boolean']>;
  numberOfChatsPerStream?: InputMaybe<Scalars['Int']>;
  privateEventPassword?: InputMaybe<Scalars['String']>;
  recordEvent?: InputMaybe<Scalars['Boolean']>;
  recordEventExpirationDate?: InputMaybe<Scalars['String']>;
};

export type IOptionsResponse = {
  allowOtherChats?: Maybe<Scalars['Boolean']>;
  isPrivateEvent?: Maybe<Scalars['Boolean']>;
  numberOfChatsPerStream?: Maybe<Scalars['Int']>;
  privateEventPassword?: Maybe<Scalars['String']>;
  recordEvent?: Maybe<Scalars['Boolean']>;
  recordEventExpirationDate?: Maybe<Scalars['String']>;
  newStreamTypeOptions?: Maybe<Scalars['String']>;
};

export type IOptionsResponseV2 = {
  allowOtherChats?: Maybe<Scalars['Boolean']>;
  isPrivateEvent?: Maybe<Scalars['Boolean']>;
  numberOfChatsPerStream?: Maybe<Scalars['Int']>;
  privateEventPassword?: Maybe<Scalars['String']>;
  recordEvent?: Maybe<Scalars['Boolean']>;
  recordEventExpirationDate?: Maybe<Scalars['String']>;
};

export type IPaymentIntentPayload = {
  clientSecret?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type IPaymentMeta = {
  stripePaymentMethod?: InputMaybe<Scalars['String']>;
};

export type IPresignedUploadInput = {
  key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type IPresignedUploadVideoInput = {
  key?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export enum IPriceInputType {
  ExactAmount = 'exactAmount',
  PriceRange = 'priceRange',
}

export enum IPriceInputTypeV2 {
  ExactAmount = 'exactAmount',
  PriceRange = 'priceRange',
}

export type IQuery = {
  checkEmailV2?: Maybe<IIsTakenResponseV2>;
  checkPpvVisit?: Maybe<ICheckPpvVisitResponse>;
  checkUsernameV2?: Maybe<IIsTakenResponseV2>;
  getAboutpage?: Maybe<IGetAboutpagePayload>;
  getAllChannels?: Maybe<Array<Maybe<IChannelResponseV2>>>;
  getAllChatMessagesForEventChat?: Maybe<IEventChatResponse>;
  getAllChatMessagesForKlicChat?: Maybe<IKlicChatResponse>;
  getAttendeesV2?: Maybe<Array<Maybe<IUserSimpleResponseV2>>>;
  getAuthorByChannelAndUser?: Maybe<IAuthorizationPayload>;
  getCategoriesV2?: Maybe<Array<Maybe<ICategoryResponseV2>>>;
  getChannelById?: Maybe<IChannelPayload>;
  getChannelV2?: Maybe<IChannelResponseV2>;
  getCredentialsLivestreaming?: Maybe<ICredentialsLivestreamingPayload>;
  getCurrentLiveStream?: Maybe<IGetCurrentLiveStreamResponse>;
  getEvent?: Maybe<IEventPayload>;
  getEventById?: Maybe<IGetEventByIdResponse>;
  getEventByIdV2?: Maybe<ISimpleEventResponse>;
  getEventChatMessagesV2?: Maybe<IEventChatMessagesResponse>;
  getEventTypesV2?: Maybe<Array<Maybe<IEventTypeResponseV2>>>;
  getEventsForCarouselV2?: Maybe<Array<Maybe<IGetEventsForCarouselV2>>>;
  getEventsForChannel?: Maybe<IListAllEventsResponseV2>;
  getEventsForVenueV2?: Maybe<IListAllEventsResponseV2>;
  getExistsChannel?: Maybe<Scalars['Boolean']>;
  getHomepageVideos?: Maybe<IGetHomepageVideosPayload>;
  getIsLiveChannel?: Maybe<Scalars['Boolean']>;
  getKlicChatMessagesV2?: Maybe<IKlicChatMessagesResponse>;
  getLandingDataV2?: Maybe<ILandingResponseV2>;
  getLandingVideos?: Maybe<IGetLandingVideos>;
  getListVideosByChannel?: Maybe<IListVideosPayload>;
  getLivestreamingByChannel?: Maybe<ILivestreamingPayload>;
  getMeV2?: Maybe<IUserResponseV2>;
  getMediasForChannel?: Maybe<Array<Maybe<IStreamResponseV2>>>;
  getPresignedUploadUrl?: Maybe<Scalars['String']>;
  getPresignedUploadVideoUrl?: Maybe<Scalars['String']>;
  getRecentVideos?: Maybe<IListVideosPayload>;
  getRecentVideosByChannel?: Maybe<IListVideosPayload>;
  getRoleById?: Maybe<IRolePayload>;
  getSignedUrlV2?: Maybe<IGetSignedUrlResponseV2>;
  getStreamV2?: Maybe<IStreamResponseV2>;
  getThumbnail?: Maybe<IGetThumbnailResponse>;
  getTransactionByUserAndEvent?: Maybe<ITransactionPayload>;
  getTransactionsByUser?: Maybe<IListTransactionsUserPayload>;
  getUserByEmail?: Maybe<IUserPayload>;
  getUserById?: Maybe<IUserPayload>;
  getUserByUsernameV2?: Maybe<IUserResponseV2>;
  getUserVenuesV2?: Maybe<Array<Maybe<IGetUserVenuesResponseV2>>>;
  getVenueByUsername?: Maybe<IVenueResponse>;
  getVenueForUser?: Maybe<IVenueResponse>;
  getVideoById?: Maybe<IVideoPayload>;
  getVideosForChannel?: Maybe<IListVideosPayload>;
  getViews?: Maybe<IEntityViewResponse>;
  listAllAuthorByChannelId?: Maybe<IListAuthorizationsPayload>;
  listAllChannels?: Maybe<IListAllChannelsResponse>;
  listAllEvents?: Maybe<IListEventsPayload>;
  listAllEventsForAdmin?: Maybe<IListEventsPayload>;
  listAllEventsForChannel?: Maybe<IListAllEventsResponse>;
  listAllRolesByChannelId?: Maybe<IListRolesPayload>;
  listAllTransactions?: Maybe<IListTransactionsPayload>;
  listEventCategories?: Maybe<IListEventCategoriesPayload>;
  listEventTypes?: Maybe<IListEventTypesPayload>;
  sendMessageContactUs?: Maybe<ISendMessagePayload>;
  userPaymentStatus?: Maybe<IUserPaymentStatusPayload>;
};

export type IQueryCheckEmailV2Args = {
  email: Scalars['String'];
};

export type IQueryCheckPpvVisitArgs = {
  cache: Scalars['String'];
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryCheckUsernameV2Args = {
  username: Scalars['String'];
};

export type IQueryGetAllChatMessagesForEventChatArgs = {
  eventId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetAllChatMessagesForKlicChatArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetAttendeesV2Args = {
  userIds: Array<InputMaybe<Scalars['String']>>;
};

export type IQueryGetAuthorByChannelAndUserArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetChannelByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetChannelV2Args = {
  username: Scalars['String'];
};

export type IQueryGetCredentialsLivestreamingArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetCurrentLiveStreamArgs = {
  channelArn: Scalars['String'];
  eventId?: InputMaybe<Scalars['String']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
};

export type IQueryGetEventArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetEventByIdArgs = {
  eventId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetEventByIdV2Args = {
  channelName: Scalars['String'];
  slug: Scalars['String'];
};

export type IQueryGetEventChatMessagesV2Args = {
  eventId: Scalars['String'];
};

export type IQueryGetEventsForChannelArgs = {
  channelId: Scalars['String'];
};

export type IQueryGetEventsForVenueV2Args = {
  venueId: Scalars['String'];
};

export type IQueryGetExistsChannelArgs = {
  subId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetIsLiveChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetKlicChatMessagesV2Args = {
  channelId: Scalars['String'];
  eventId: Scalars['String'];
};

export type IQueryGetLandingDataV2Args = {
  withVod?: InputMaybe<Scalars['Boolean']>;
};

export type IQueryGetListVideosByChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetLivestreamingByChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetMeV2Args = {
  token: Scalars['String'];
};

export type IQueryGetMediasForChannelArgs = {
  username: Scalars['String'];
};

export type IQueryGetPresignedUploadUrlArgs = {
  presignedUploadInput?: InputMaybe<IPresignedUploadInput>;
};

export type IQueryGetPresignedUploadVideoUrlArgs = {
  presignedUploadVideoInput?: InputMaybe<IPresignedUploadVideoInput>;
};

export type IQueryGetRecentVideosByChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetRoleByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetSignedUrlV2Args = {
  key: Scalars['String'];
};

export type IQueryGetStreamV2Args = {
  getStreamInput?: InputMaybe<IGetStreamInput>;
};

export type IQueryGetThumbnailArgs = {
  path: Scalars['String'];
};

export type IQueryGetTransactionByUserAndEventArgs = {
  eventId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetTransactionsByUserArgs = {
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetUserByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};

export type IQueryGetUserByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetUserByUsernameV2Args = {
  username: Scalars['String'];
};

export type IQueryGetUserVenuesV2Args = {
  userId: Scalars['String'];
};

export type IQueryGetVenueByUsernameArgs = {
  username: Scalars['String'];
};

export type IQueryGetVenueForUserArgs = {
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetVideoByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetVideosForChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetViewsArgs = {
  id: Scalars['String'];
  type: Scalars['String'];
};

export type IQueryListAllAuthorByChannelIdArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};

export type IQueryListAllEventsForChannelArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};

export type IQueryListAllRolesByChannelIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQuerySendMessageContactUsArgs = {
  email?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type IQueryUserPaymentStatusArgs = {
  paymentStatusPayload?: InputMaybe<IUserPaymentStatusInput>;
};

export type IRemoveEventResponse = {
  data?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type IRole = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  roleState?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IRolePayload = {
  error?: Maybe<Scalars['String']>;
  role?: Maybe<IRole>;
};

export type IRoleResponseV2 = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ISendMessageEventChatResponse = {
  data?: Maybe<IChatDataResponse>;
  event?: Maybe<Scalars['String']>;
};

export type ISendMessageKlicChatResponse = {
  channel?: Maybe<Scalars['String']>;
  data?: Maybe<IChatDataResponse>;
  event?: Maybe<Scalars['String']>;
};

export type ISendMessagePayload = {
  error?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type IShowcaseEvent = {
  eventDescription?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventTitle?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  stream?: Maybe<IStream>;
  streamUrl?: Maybe<Scalars['String']>;
};

export type IShowcaseEventData = {
  event?: Maybe<IEventData>;
  eventDescription?: Maybe<Scalars['String']>;
  eventTitle?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  stream?: Maybe<IStream>;
  streamUrl?: Maybe<Scalars['String']>;
};

export type IShowcaseEventInput = {
  eventDescription?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  eventTitle?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  stream?: InputMaybe<IStreamInput>;
  streamUrl?: InputMaybe<Scalars['String']>;
};

export type ISignupPayload = {
  email: Scalars['AWSEmail'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ISimpleChannelResponseV2 = {
  channelArn?: Maybe<Scalars['String']>;
  channelInputUrl?: Maybe<Scalars['String']>;
  channelStreamKey?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isChannelLive?: Maybe<Scalars['String']>;
  followerCount?: Maybe<Scalars['String']>;
  ivsChannelName?: Maybe<Scalars['String']>;
  liveUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<ISimpleChannelUserResponse>;
  userId?: Maybe<Scalars['String']>;
};

export type ISimpleChannelUserResponse = {
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export type ISimpleEventResponse = {
  attendees?: Maybe<Array<Maybe<Scalars['String']>>>;
  availableActions?: Maybe<IAvailableActionsTypeV2>;
  createdAt?: Maybe<Scalars['String']>;
  details?: Maybe<IDetailsResponseV2>;
  eventStartedAt?: Maybe<Scalars['String']>;
  eventStoppedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  monetization?: Maybe<IMonetizationResponseV2>;
  options?: Maybe<IOptionsResponseV2>;
  slug?: Maybe<Scalars['String']>;
  featuredPosition?: Maybe<Scalars['Int']>;
  status?: Maybe<IStatusTypeV2>;
  streamers?: Maybe<Array<Maybe<IStreamersResponseV2>>>;
  viewers?: Maybe<IEntityViewResponse>;
};

export type ISimpleVenueResponseV2 = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ISponsor = {
  index?: Maybe<Scalars['String']>;
  sponsorLogo?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ISponsorInput = {
  index?: InputMaybe<Scalars['String']>;
  sponsorLogo?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export enum IStatusType {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Past = 'PAST',
  Recorded = 'RECORDED',
  Scheduled = 'SCHEDULED',
}

export enum IStatusTypeV2 {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Past = 'PAST',
  Recorded = 'RECORDED',
  Scheduled = 'SCHEDULED',
}

export type IStream = {
  chatKlic?: Maybe<IChat>;
  chatsOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  discordChatUrl?: Maybe<Scalars['String']>;
  embedCode?: Maybe<Scalars['String']>;
  facebookChatUrl?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  homeThumbnailVod?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  streamPosition?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  subHeading?: Maybe<Scalars['String']>;
  techName?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  twitchChatUrl?: Maybe<Scalars['String']>;
  viewers?: Maybe<Scalars['Int']>;
  youtubeChatCode?: Maybe<Scalars['String']>;
};

export type IStreamInput = {
  chatKlic?: InputMaybe<IChatInput>;
  chatsOrder?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  discordChatUrl?: InputMaybe<Scalars['String']>;
  embedCode?: InputMaybe<Scalars['String']>;
  facebookChatUrl?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
  homeThumbnailVod?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  streamPosition?: InputMaybe<Scalars['String']>;
  streamUrl?: InputMaybe<Scalars['String']>;
  subHeading?: InputMaybe<Scalars['String']>;
  techName?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  twitchChatUrl?: InputMaybe<Scalars['String']>;
  viewers?: InputMaybe<Scalars['Int']>;
  youtubeChatCode?: InputMaybe<Scalars['String']>;
};

export type IStreamResponseV2 = {
  id?: Maybe<Scalars['String']>;
  isChannelLive?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  livePlaybackUrl?: Maybe<Scalars['String']>;
  masterKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  playlistDuration?: Maybe<Scalars['String']>;
  recordingStartedAt?: Maybe<Scalars['String']>;
};

export type IStreamerInput = {
  chatsOrder?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discordChatUrl?: InputMaybe<Scalars['String']>;
  facebookChatUrl?: InputMaybe<Scalars['String']>;
  streamTech?: InputMaybe<Scalars['String']>;
  streamerLogo?: InputMaybe<IFileInput>;
  streamerThumbnail?: InputMaybe<IFileInput>;
  streamerTitle?: InputMaybe<Scalars['String']>;
  streamerUrl?: InputMaybe<Scalars['String']>;
  subHeading?: InputMaybe<Scalars['String']>;
  twitchChatUrl?: InputMaybe<Scalars['String']>;
  youtubeChatCode?: InputMaybe<Scalars['String']>;
};

export type IStreamers = {
  emailInvite?: InputMaybe<IEmailInvite>;
  embedStreams?: InputMaybe<IEmbedStreams>;
  klic?: InputMaybe<IKlic>;
  type: IStreamsType;
};

export type IStreamersAsDraft = {
  emailInvite?: InputMaybe<IEmailInviteAsDraft>;
  embedStreams?: InputMaybe<IEmbedStreamsAsDraft>;
  klic?: InputMaybe<IKlicAsDraft>;
  type?: InputMaybe<IStreamsType>;
};

export type IStreamersAsDraftEditV2 = {
  emailInvite?: InputMaybe<IEmailInviteAsDraft>;
  embedStreams?: InputMaybe<IEmbedStreamsAsDraftV2>;
  id?: InputMaybe<Scalars['String']>;
  klic?: InputMaybe<IKlicAsDraftV2>;
  type?: InputMaybe<IStreamsTypeV2>;
};

export type IStreamersAsDraftV2 = {
  emailInvite?: InputMaybe<IEmailInviteAsDraft>;
  embedStreams?: InputMaybe<IEmbedStreamsAsDraftV2>;
  klic?: InputMaybe<IKlicAsDraftV2>;
  type?: InputMaybe<IStreamsTypeV2>;
};

export type IStreamersChat = {
  type: Scalars['String'];
  url: Scalars['String'];
};

export type IStreamersChatAsDraft = {
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type IStreamersChatAsDraftV2 = {
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type IStreamersChatResponse = {
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type IStreamersChatResponseV2 = {
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type IStreamersChatV2 = {
  type: Scalars['String'];
  url: Scalars['String'];
};

export type IStreamersResponse = {
  emailInvite?: Maybe<IEmailInviteResponse>;
  embedStreams?: Maybe<IEmbedStreamsResponse>;
  klic?: Maybe<IKlicResponse>;
  type?: Maybe<IStreamsType>;
};

export type IStreamersResponseV2 = {
  emailInvite?: Maybe<IEmailInviteResponseV2>;
  embedStreams?: Maybe<IEmbedStreamsResponseV2>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isPromo?: Maybe<Scalars['Boolean']>;
  klic?: Maybe<IKlicResponseV2>;
  media?: Maybe<IStreamResponseV2>;
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<IStreamsTypeV2>;
  viewers?: Maybe<IEntityViewResponse>;
};

export enum IStreamsType {
  EmailInvite = 'EMAIL_INVITE',
  EmbedStreams = 'EMBED_STREAMS',
  Klic = 'KLIC',
}

export enum IStreamsTypeV2 {
  EmailInvite = 'EMAIL_INVITE',
  EmbedStreams = 'EMBED_STREAMS',
  Klic = 'KLIC',
}

export type ISubscription = {
  onAttendEventV2?: Maybe<IAttendEventResponse>;
  onAttendUpdate?: Maybe<IAttendEventResponse>;
  onSendMessageChatKlic?: Maybe<IMessagePayload>;
  onSendMessageEventChat?: Maybe<IEventChatMessageSentResponse>;
  onNewSendMessageEventChatV2?: Maybe<ISendMessageEventChatResponse>;
  onSendMessageKlicChat?: Maybe<IKlicChatMessageSentResponse>;
  onSendMessageKlicChatV2?: Maybe<ISendMessageKlicChatResponse>;
  onStartStreamerByAdmin?: Maybe<IStreamersResponseV2>;
  onStopStreamerByAdmin?: Maybe<IStreamersResponseV2>;
  onUpdateEventViewers?: Maybe<IUpdateEventViewersResponse>;
  onUpdateEventViews?: Maybe<IUpdateEventViewsResponse>;
  onViewerNumberChange?: Maybe<IEntityViewResponse>;
};

export type ISubscriptionOnUpdateEventViewsArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type ITestimonial = {
  btnText?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  testimony?: Maybe<Scalars['String']>;
  urlInfo?: Maybe<Scalars['String']>;
};

export type ITestimonialData = {
  btnText?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  testimony?: Maybe<Scalars['String']>;
  urlInfo?: Maybe<Scalars['String']>;
};

export type ITransaction = {
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receipt_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ITransactionPayload = {
  error?: Maybe<Scalars['String']>;
  transaction?: Maybe<ITransaction>;
};

export type ITransactionUser = {
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receipt_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ITrustedBy = {
  img?: Maybe<Scalars['String']>;
};

export type ITrustedByData = {
  img?: Maybe<Scalars['String']>;
};

export type IUpcomingEvent = {
  event?: Maybe<IEvent>;
  eventId?: Maybe<Scalars['String']>;
};

export type IUpcomingEventData = {
  event?: Maybe<IEvent>;
  eventId?: Maybe<Scalars['String']>;
};

export type IUpcomingEventInput = {
  eventId?: InputMaybe<Scalars['String']>;
};

export type IUpdateAboutpageInput = {
  aboutFeatures?: InputMaybe<Array<InputMaybe<IAboutFeatureInput>>>;
  details?: InputMaybe<IAboutDetailsInput>;
  testimonials?: InputMaybe<Array<InputMaybe<ITestimonialInput>>>;
  trustedBy?: InputMaybe<Array<InputMaybe<ITrustedByInput>>>;
  upcomingEvents?: InputMaybe<Array<InputMaybe<IUpcomingEventInput>>>;
};

export type IUpdateAuthorizationInput = {
  authState?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IUpdateCategoryInput = {
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IUpdateChannelInput = {
  banner?: InputMaybe<Scalars['String']>;
  channelArn?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imagen?: InputMaybe<Scalars['String']>;
  ingestServer?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  streamKey?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  watermark?: InputMaybe<Scalars['String']>;
};

export type IUpdateEventCategoryInput = {
  eventCategory?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type IUpdateEventInput = {
  address?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  chats?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endTime?: InputMaybe<Scalars['String']>;
  ended?: InputMaybe<Scalars['Boolean']>;
  eventDate?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventTime?: InputMaybe<Scalars['String']>;
  eventTimezone?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  imgDescription?: InputMaybe<Scalars['String']>;
  organizer?: InputMaybe<Scalars['String']>;
  paidEvent?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  priceId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sponsorLogos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sponsors?: InputMaybe<Array<InputMaybe<ISponsorInput>>>;
  startTime?: InputMaybe<Scalars['String']>;
  streamData?: InputMaybe<Array<InputMaybe<IStreamInput>>>;
  streamingFrom?: InputMaybe<Scalars['String']>;
  subHeading?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalStreamViews?: InputMaybe<Scalars['Int']>;
  totalViews?: InputMaybe<Scalars['Int']>;
  viewedUser?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  viewers?: InputMaybe<Scalars['Int']>;
};

export type IUpdateEventTypeInput = {
  eventType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type IUpdateEventViewersResponse = {
  email?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  viewers?: Maybe<IEventDataViewersResponse>;
};

export type IUpdateEventViewsResponse = {
  email?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  totalViews?: Maybe<IEventDataResponse>;
};

export type IUpdateHomepageVideosInput = {
  featuredEvents?: InputMaybe<Array<InputMaybe<IFeaturedEventInput>>>;
  recentVods?: InputMaybe<Array<InputMaybe<IFeaturedEventInput>>>;
  showcaseEvents?: InputMaybe<Array<InputMaybe<IShowcaseEventInput>>>;
};

export type IUpdateLivestreamingInput = {
  autoRecord?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  forChilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type IUpdateUserInput = {
  avatar?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type IUpdateUserProfileInput = {
  avatar?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type IUpdateUserProfileResponseV2 = {
  avatar?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type IUpdateVenueInput = {
  description?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  instagramUrl?: InputMaybe<Scalars['String']>;
  isDirty?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  tikTokUrl?: InputMaybe<Scalars['String']>;
  twitchUrl?: InputMaybe<Scalars['String']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type IUpdateVenueResponseV2 = {
  description: Scalars['String'];
  facebookUrl: Scalars['String'];
  id: Scalars['String'];
  instagramUrl: Scalars['String'];
  isDirty: Scalars['Boolean'];
  name: Scalars['String'];
  tikTokUrl: Scalars['String'];
  twitchUrl: Scalars['String'];
  twitterUrl: Scalars['String'];
  websiteUrl: Scalars['String'];
};

export type IUpdateVideoInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  forChilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['String']>;
  recordingSessionId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnail?: InputMaybe<Scalars['String']>;
  thumbnailsPath?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type IUser = {
  avatar?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userData?: Maybe<IUserData>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type IUserData = {
  avatar?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  displayEmail?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['String']>;
};

export type IUserDataInput = {
  userDisplayName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IUserPayload = {
  error?: Maybe<Scalars['String']>;
  user?: Maybe<IUser>;
};

export type IUserPaymentStatusInput = {
  eventId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IUserPaymentStatusPayload = {
  error?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Boolean']>;
};

export type IUserResponseV2 = {
  avatar?: Maybe<Scalars['String']>;
  channel?: Maybe<ISimpleChannelResponseV2>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  role: IRoleResponseV2;
  username: Scalars['String'];
  venues?: Maybe<Array<Maybe<ISimpleVenueResponseV2>>>;
};

export type IUserSimpleResponseV2 = {
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  heading?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  roleId: Scalars['String'];
  username: Scalars['String'];
};

export type IVenueResponse = {
  description?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  isDirty?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tikTokUrl?: Maybe<Scalars['String']>;
  twitchUrl?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  venue?: Maybe<IVenueResponseDataPayload>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type IVenueResponseData = {
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type IVenueResponseDataPayload = {
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  item?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  venueData?: Maybe<IVenueResponseData>;
};

export type IVideo = {
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  forChilds?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  playbackUrl?: Maybe<Scalars['String']>;
  privacy?: Maybe<Scalars['String']>;
  recordingSessionId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnail?: Maybe<Scalars['String']>;
  thumbnailsPath?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IVideoData = {
  featuredEvents?: Maybe<Array<Maybe<IFeaturedEvent>>>;
  recentVods?: Maybe<Array<Maybe<IFeaturedEvent>>>;
  showcaseEvents?: Maybe<Array<Maybe<IShowcaseEvent>>>;
};

export type IVideoPayload = {
  error?: Maybe<Scalars['String']>;
  video?: Maybe<IVideo>;
};

export type IAboutDetailsInput = {
  btnHeroLink?: InputMaybe<Scalars['String']>;
  btnHeroText?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  imgInitial?: InputMaybe<Scalars['String']>;
  supportingCopy?: InputMaybe<Scalars['String']>;
  testimonialWaterMark?: InputMaybe<Scalars['String']>;
  testimonialsTitle?: InputMaybe<Scalars['String']>;
  trustedTitle?: InputMaybe<Scalars['String']>;
  upcomingEventTitle?: InputMaybe<Scalars['String']>;
  upcomingEventWaterMark?: InputMaybe<Scalars['String']>;
};

export type IAboutFeatureInput = {
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  img?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ITestimonialInput = {
  btnText?: InputMaybe<Scalars['String']>;
  img?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  testimony?: InputMaybe<Scalars['String']>;
  urlInfo?: InputMaybe<Scalars['String']>;
};

export type ITrustedByInput = {
  img?: InputMaybe<Scalars['String']>;
};

export type IGetChannelByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;

export type IGetChannelByIdQuery = {
  getChannelById?: {
    error?: string | null;
    channel?: {
      channelArn?: string | null;
      banner?: string | null;
      createdAt?: string | null;
      description?: string | null;
      id?: string | null;
      ingestServer?: string | null;
      imagen?: string | null;
      isLive?: boolean | null;
      name?: string | null;
      playbackUrl?: string | null;
      streamKey?: string | null;
      subId?: string | null;
      thumbnailUrl?: string | null;
      updatedAt?: string | null;
      userId?: string | null;
      watermark?: string | null;
      channelData?: {
        banner?: string | null;
        displayName?: string | null;
        id?: string | null;
        image?: string | null;
        ingestServer?: string | null;
        isLive?: boolean | null;
        name?: string | null;
        playbackUrl?: string | null;
        streamArn?: string | null;
        streamKey?: string | null;
        userId?: string | null;
      } | null;
    } | null;
  } | null;
};

export type IListAllEventsForChannelQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['String']>;
}>;

export type IListAllEventsForChannelQuery = {
  listAllEventsForChannel?: {
    error?: string | null;
    events?: Array<{
      createdAt?: string | null;
      id?: string | null;
      status?: IStatusType | null;
      attendees?: Array<{
        userId?: string | null;
        userDisplayName?: string | null;
        attendDateAndTime?: string | null;
      } | null> | null;
      availableActions?: {
        edit?: boolean | null;
        start?: boolean | null;
        finish?: boolean | null;
        archive?: boolean | null;
        remove?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        preRoll?: boolean | null;
        allowFreePreview?: boolean | null;
        freePreviewTime?: string | null;
        allowFreePreviewSub?: boolean | null;
        subscribersOnly?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        freePreviewTimeSub?: string | null;
        contributorsOptions?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationType | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputType | null;
        pricePerPPVSub?: string | null;
        pricePerPPV?: string | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
      } | null;
      streamers?: Array<{
        type?: IStreamsType | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          thumbnailUrl?: string | null;
          streamUrl?: string | null;
          channel?: {
            name?: string | null;
            userId?: string | null;
            item?: string | null;
            createdAt?: string | null;
            id?: string | null;
            thumbnailUrl?: string | null;
          } | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type IListEventCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IListEventCategoriesQuery = {
  listEventCategories?: {
    error?: string | null;
    eventCategories?: Array<{
      id?: string | null;
      eventCategory?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
  } | null;
};

export type IListEventTypesQueryVariables = Exact<{ [key: string]: never }>;

export type IListEventTypesQuery = {
  listEventTypes?: {
    error?: string | null;
    eventTypes?: Array<{
      id?: string | null;
      eventType?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
  } | null;
};

export type IGetEventByIdQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['String']>;
}>;

export type IGetEventByIdQuery = {
  getEventById?: {
    error?: string | null;
    event?: {
      createdAt?: string | null;
      id?: string | null;
      status?: IStatusType | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
      } | null;
      attendees?: Array<{
        userId?: string | null;
        userDisplayName?: string | null;
        attendDateAndTime?: string | null;
      } | null> | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        preRoll?: boolean | null;
        allowFreePreview?: boolean | null;
        freePreviewTime?: string | null;
        allowFreePreviewSub?: boolean | null;
        subscribersOnly?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        freePreviewTimeSub?: string | null;
        contributorsOptions?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationType | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputType | null;
        pricePerPPVSub?: string | null;
        pricePerPPV?: string | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      availableActions?: {
        edit?: boolean | null;
        start?: boolean | null;
        finish?: boolean | null;
        archive?: boolean | null;
        remove?: boolean | null;
      } | null;
      streamers?: Array<{
        type?: IStreamsType | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          thumbnailUrl?: string | null;
          streamUrl?: string | null;
          channel?: {
            name?: string | null;
            userId?: string | null;
            item?: string | null;
            createdAt?: string | null;
            id?: string | null;
            thumbnailUrl?: string | null;
            channelData?: {
              banner?: string | null;
              displayName?: string | null;
              id?: string | null;
              image?: string | null;
              ingestServer?: string | null;
              isLive?: boolean | null;
              name?: string | null;
              playbackUrl?: string | null;
              streamArn?: string | null;
              streamKey?: string | null;
              userId?: string | null;
            } | null;
          } | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
      } | null> | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
      } | null;
    } | null;
  } | null;
};

export type IGetLandingVideosQueryVariables = Exact<{ [key: string]: never }>;

export type IGetLandingVideosQuery = {
  getLandingVideos?: {
    error?: string | null;
    featuredEvents?: Array<{
      createdAt?: string | null;
      id?: string | null;
      status?: IStatusType | null;
      details?: {
        duration?: number | null;
        eventDescription?: string | null;
        eventCategory?: Array<string | null> | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventStartDateAndTime?: string | null;
        eventPosterImage?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
      } | null;
      attendees?: Array<{
        userId?: string | null;
        userDisplayName?: string | null;
        attendDateAndTime?: string | null;
      } | null> | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        preRoll?: boolean | null;
        allowFreePreview?: boolean | null;
        freePreviewTime?: string | null;
        allowFreePreviewSub?: boolean | null;
        subscribersOnly?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        freePreviewTimeSub?: string | null;
        contributorsOptions?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationType | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputType | null;
        pricePerPPVSub?: string | null;
        pricePerPPV?: string | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
      } | null;
      availableActions?: {
        edit?: boolean | null;
        start?: boolean | null;
        finish?: boolean | null;
        archive?: boolean | null;
        remove?: boolean | null;
      } | null;
      streamers?: Array<{
        type?: IStreamsType | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          thumbnailUrl?: string | null;
          streamUrl?: string | null;
          channel?: {
            name?: string | null;
            userId?: string | null;
            item?: string | null;
            createdAt?: string | null;
            id?: string | null;
            thumbnailUrl?: string | null;
          } | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
      } | null> | null;
    } | null> | null;
    liveEvents?: Array<{
      createdAt?: string | null;
      id?: string | null;
      status?: IStatusType | null;
      details?: {
        duration?: number | null;
        eventDescription?: string | null;
        eventCategory?: Array<string | null> | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventStartDateAndTime?: string | null;
        eventPosterImage?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
      } | null;
      attendees?: Array<{
        userId?: string | null;
        userDisplayName?: string | null;
        attendDateAndTime?: string | null;
      } | null> | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        preRoll?: boolean | null;
        allowFreePreview?: boolean | null;
        freePreviewTime?: string | null;
        allowFreePreviewSub?: boolean | null;
        subscribersOnly?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        freePreviewTimeSub?: string | null;
        contributorsOptions?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationType | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputType | null;
        pricePerPPVSub?: string | null;
        pricePerPPV?: string | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
      } | null;
      availableActions?: {
        edit?: boolean | null;
        start?: boolean | null;
        finish?: boolean | null;
        archive?: boolean | null;
        remove?: boolean | null;
      } | null;
      streamers?: Array<{
        type?: IStreamsType | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          thumbnailUrl?: string | null;
          streamUrl?: string | null;
          channel?: {
            name?: string | null;
            userId?: string | null;
            item?: string | null;
            createdAt?: string | null;
            id?: string | null;
            thumbnailUrl?: string | null;
          } | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
      } | null> | null;
    } | null> | null;
    scheduledEvents?: Array<{
      createdAt?: string | null;
      id?: string | null;
      status?: IStatusType | null;
      details?: {
        duration?: number | null;
        eventDescription?: string | null;
        eventCategory?: Array<string | null> | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventStartDateAndTime?: string | null;
        eventPosterImage?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
      } | null;
      attendees?: Array<{
        userId?: string | null;
        userDisplayName?: string | null;
        attendDateAndTime?: string | null;
      } | null> | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        preRoll?: boolean | null;
        allowFreePreview?: boolean | null;
        freePreviewTime?: string | null;
        allowFreePreviewSub?: boolean | null;
        subscribersOnly?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        freePreviewTimeSub?: string | null;
        contributorsOptions?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationType | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputType | null;
        pricePerPPVSub?: string | null;
        pricePerPPV?: string | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
      } | null;
      availableActions?: {
        edit?: boolean | null;
        start?: boolean | null;
        finish?: boolean | null;
        archive?: boolean | null;
        remove?: boolean | null;
      } | null;
      streamers?: Array<{
        type?: IStreamsType | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          thumbnailUrl?: string | null;
          streamUrl?: string | null;
          channel?: {
            name?: string | null;
            userId?: string | null;
            item?: string | null;
            createdAt?: string | null;
            id?: string | null;
            thumbnailUrl?: string | null;
          } | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ICreateEventV2MutationVariables = Exact<{
  createEventForChannelAsDraftRequest?: InputMaybe<ICreateEventForChannelAsDraftInput>;
}>;

export type ICreateEventV2Mutation = {
  createEventV2?: {
    error?: string | null;
    data?: { event?: string | null; status?: number | null } | null;
  } | null;
};

export type IAttendEventMutationVariables = Exact<{
  eventId?: InputMaybe<Scalars['String']>;
  userData?: InputMaybe<IUserDataInput>;
}>;

export type IAttendEventMutation = {
  attendEvent?: {
    error?: string | null;
    event?: {
      id?: string | null;
      createdAt?: string | null;
      attendees?: Array<{
        attendDateAndTime?: string | null;
        userDisplayName?: string | null;
        userId?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type IOnAttendUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnAttendUpdateSubscription = {
  onAttendUpdate?: {
    error?: string | null;
    event?: {
      id?: string | null;
      attendees?: Array<{
        attendDateAndTime?: string | null;
        userDisplayName?: string | null;
        userId?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ISendMessageEventChatMutationVariables = Exact<{
  eventId?: InputMaybe<Scalars['String']>;
  chatData?: InputMaybe<IChatDataInput>;
}>;

export type ISendMessageEventChatMutation = {
  sendMessageEventChat?: {
    error?: string | null;
    event?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};

export type IOnSendMessageEventChatSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnSendMessageEventChatSubscription = {
  onSendMessageEventChat?: {
    error?: string | null;
    event?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};

export type IGetAllChatMessagesForEventChatQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['String']>;
}>;

export type IGetAllChatMessagesForEventChatQuery = {
  getAllChatMessagesForEventChat?: {
    error?: string | null;
    messages?: Array<{
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
  } | null;
};

export type ISendMessageKlicChatMutationVariables = Exact<{
  eventId?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  chatData?: InputMaybe<IChatDataInput>;
}>;

export type ISendMessageKlicChatMutation = {
  sendMessageKlicChat?: {
    error?: string | null;
    event?: string | null;
    channel?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};

export type IOnSendMessageKlicChatSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnSendMessageKlicChatSubscription = {
  onSendMessageKlicChat?: {
    error?: string | null;
    event?: string | null;
    channel?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};

export type IGetAllChatMessagesForKlicChatQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
}>;

export type IGetAllChatMessagesForKlicChatQuery = {
  getAllChatMessagesForKlicChat?: {
    error?: string | null;
    channel?: string | null;
    messages?: Array<{
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
  } | null;
};

export type IGetUserByEmailQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;

export type IGetUserByEmailQuery = {
  getUserByEmail?: {
    error?: string | null;
    user?: {
      avatar?: string | null;
      channelId?: string | null;
      createdAt?: string | null;
      email?: string | null;
      firstName?: string | null;
      id?: string | null;
      lastName?: string | null;
      updatedAt?: string | null;
      userId?: string | null;
      userName?: string | null;
      userData?: {
        avatar?: string | null;
        channelId?: string | null;
        displayEmail?: string | null;
        displayName?: string | null;
        email?: string | null;
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        role?: string | null;
        username?: string | null;
        venueId?: string | null;
      } | null;
    } | null;
  } | null;
};

export type IGetVenueForUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;

export type IGetVenueForUserQuery = {
  getVenueForUser?: {
    message?: string | null;
    venue?: {
      id?: string | null;
      createdAt?: string | null;
      item?: string | null;
      updatedAt?: string | null;
      venueData?: {
        description?: string | null;
        name?: string | null;
        owner?: Array<string | null> | null;
      } | null;
    } | null;
  } | null;
};

export type IUpdateUserProfileMutationVariables = Exact<{
  updateUserPayload?: InputMaybe<IUpdateUserInput>;
}>;

export type IUpdateUserProfileMutation = {
  updateUserProfile?: {
    error?: string | null;
    user?: {
      id?: string | null;
      userId?: string | null;
      channelId?: string | null;
      userName?: string | null;
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
  } | null;
};

export const GetChannelByIdDocument = gql`
  query getChannelById($id: String) {
    getChannelById(id: $id) {
      channel {
        channelData {
          banner
          displayName
          id
          image
          ingestServer
          isLive
          name
          playbackUrl
          streamArn
          streamKey
          userId
        }
        channelArn
        banner
        createdAt
        description
        id
        ingestServer
        imagen
        isLive
        name
        playbackUrl
        streamKey
        subId
        thumbnailUrl
        updatedAt
        userId
        watermark
      }
      error
    }
  }
`;
export const ListAllEventsForChannelDocument = gql`
  query listAllEventsForChannel($channelId: String) {
    listAllEventsForChannel(channelId: $channelId) {
      error
      events {
        createdAt
        id
        attendees {
          userId
          userDisplayName
          attendDateAndTime
        }
        status
        availableActions {
          edit
          start
          finish
          archive
          remove
        }
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
        }
        monetization {
          adFrequency
          adLength
          preRoll
          allowFreePreview
          freePreviewTime
          allowFreePreviewSub
          subscribersOnly
          allowNonSubscribersPPV
          allowPPVSub
          freePreviewTimeSub
          contributorsOptions
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPVSub
          pricePerPPV
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
        }
        streamers {
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            thumbnailUrl
            streamUrl
            channel {
              name
              userId
              item
              createdAt
              id
              thumbnailUrl
            }
            chat {
              type
              url
            }
          }
          type
        }
      }
    }
  }
`;
export const ListEventCategoriesDocument = gql`
  query listEventCategories {
    listEventCategories {
      eventCategories {
        id
        eventCategory
        createdAt
        updatedAt
      }
      error
    }
  }
`;
export const ListEventTypesDocument = gql`
  query listEventTypes {
    listEventTypes {
      eventTypes {
        id
        eventType
        createdAt
        updatedAt
      }
      error
    }
  }
`;
export const GetEventByIdDocument = gql`
  query getEventById($eventId: String) {
    getEventById(eventId: $eventId) {
      error
      event {
        createdAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
        }
        id
        attendees {
          userId
          userDisplayName
          attendDateAndTime
        }
        monetization {
          adFrequency
          adLength
          preRoll
          allowFreePreview
          freePreviewTime
          allowFreePreviewSub
          subscribersOnly
          allowNonSubscribersPPV
          allowPPVSub
          freePreviewTimeSub
          contributorsOptions
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPVSub
          pricePerPPV
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
        }
        status
        availableActions {
          edit
          start
          finish
          archive
          remove
        }
        streamers {
          type
          klic {
            isThumbnailOverridden
            logo
            thumbnailUrl
            streamUrl
            channel {
              name
              userId
              item
              createdAt
              id
              thumbnailUrl
              channelData {
                banner
                displayName
                id
                image
                ingestServer
                isLive
                name
                playbackUrl
                streamArn
                streamKey
                userId
              }
            }
            chat {
              type
              url
            }
          }
          embedStreams {
            chat {
              type
              url
            }
            logo
            streamName
            streamType
            streamUrl
            thumbnail
          }
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
        }
      }
    }
  }
`;
export const GetLandingVideosDocument = gql`
  query getLandingVideos {
    getLandingVideos {
      featuredEvents {
        createdAt
        details {
          duration
          eventDescription
          eventCategory
          eventName
          eventOwner
          eventStartDateAndTime
          eventPosterImage
          eventThumbnail
          eventType
        }
        id
        attendees {
          userId
          userDisplayName
          attendDateAndTime
        }
        monetization {
          adFrequency
          adLength
          preRoll
          allowFreePreview
          freePreviewTime
          allowFreePreviewSub
          subscribersOnly
          allowNonSubscribersPPV
          allowPPVSub
          freePreviewTimeSub
          contributorsOptions
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPVSub
          pricePerPPV
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
        }
        status
        availableActions {
          edit
          start
          finish
          archive
          remove
        }
        streamers {
          type
          klic {
            isThumbnailOverridden
            logo
            thumbnailUrl
            streamUrl
            channel {
              name
              userId
              item
              createdAt
              id
              thumbnailUrl
            }
            chat {
              type
              url
            }
          }
          embedStreams {
            chat {
              type
              url
            }
            logo
            streamName
            streamType
            streamUrl
            thumbnail
          }
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
        }
      }
      liveEvents {
        createdAt
        details {
          duration
          eventDescription
          eventCategory
          eventName
          eventOwner
          eventStartDateAndTime
          eventPosterImage
          eventThumbnail
          eventType
        }
        id
        attendees {
          userId
          userDisplayName
          attendDateAndTime
        }
        monetization {
          adFrequency
          adLength
          preRoll
          allowFreePreview
          freePreviewTime
          allowFreePreviewSub
          subscribersOnly
          allowNonSubscribersPPV
          allowPPVSub
          freePreviewTimeSub
          contributorsOptions
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPVSub
          pricePerPPV
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
        }
        status
        availableActions {
          edit
          start
          finish
          archive
          remove
        }
        streamers {
          type
          klic {
            isThumbnailOverridden
            logo
            thumbnailUrl
            streamUrl
            channel {
              name
              userId
              item
              createdAt
              id
              thumbnailUrl
            }
            chat {
              type
              url
            }
          }
          embedStreams {
            chat {
              type
              url
            }
            logo
            streamName
            streamType
            streamUrl
            thumbnail
          }
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
        }
      }
      scheduledEvents {
        createdAt
        details {
          duration
          eventDescription
          eventCategory
          eventName
          eventOwner
          eventStartDateAndTime
          eventPosterImage
          eventThumbnail
          eventType
        }
        id
        attendees {
          userId
          userDisplayName
          attendDateAndTime
        }
        monetization {
          adFrequency
          adLength
          preRoll
          allowFreePreview
          freePreviewTime
          allowFreePreviewSub
          subscribersOnly
          allowNonSubscribersPPV
          allowPPVSub
          freePreviewTimeSub
          contributorsOptions
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPVSub
          pricePerPPV
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
        }
        status
        availableActions {
          edit
          start
          finish
          archive
          remove
        }
        streamers {
          type
          klic {
            isThumbnailOverridden
            logo
            thumbnailUrl
            streamUrl
            channel {
              name
              userId
              item
              createdAt
              id
              thumbnailUrl
            }
            chat {
              type
              url
            }
          }
          embedStreams {
            chat {
              type
              url
            }
            logo
            streamName
            streamType
            streamUrl
            thumbnail
          }
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
        }
      }
      error
    }
  }
`;
export const CreateEventV2Document = gql`
  mutation createEventV2(
    $createEventForChannelAsDraftRequest: CreateEventForChannelAsDraftInput
  ) {
    createEventV2(
      createEventForChannelAsDraftRequest: $createEventForChannelAsDraftRequest
    ) {
      error
      data {
        event
        status
      }
    }
  }
`;
export const AttendEventDocument = gql`
  mutation attendEvent($eventId: String, $userData: UserDataInput) {
    attendEvent(eventId: $eventId, userData: $userData) {
      error
      event {
        attendees {
          attendDateAndTime
          userDisplayName
          userId
        }
        id
        createdAt
      }
    }
  }
`;
export const OnAttendUpdateDocument = gql`
  subscription onAttendUpdate {
    onAttendUpdate {
      error
      event {
        attendees {
          attendDateAndTime
          userDisplayName
          userId
        }
        id
      }
    }
  }
`;
export const SendMessageEventChatDocument = gql`
  mutation sendMessageEventChat($eventId: String, $chatData: ChatDataInput) {
    sendMessageEventChat(eventId: $eventId, chatData: $chatData) {
      error
      event
      data {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const OnSendMessageEventChatDocument = gql`
  subscription onSendMessageEventChat {
    onSendMessageEventChat {
      error
      event
      data {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const GetAllChatMessagesForEventChatDocument = gql`
  query getAllChatMessagesForEventChat($eventId: String) {
    getAllChatMessagesForEventChat(eventId: $eventId) {
      error
      messages {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const SendMessageKlicChatDocument = gql`
  mutation sendMessageKlicChat(
    $eventId: String
    $channelId: String
    $chatData: ChatDataInput
  ) {
    sendMessageKlicChat(
      eventId: $eventId
      channelId: $channelId
      chatData: $chatData
    ) {
      error
      event
      channel
      data {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const OnSendMessageKlicChatDocument = gql`
  subscription onSendMessageKlicChat {
    onSendMessageKlicChat {
      error
      event
      channel
      data {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const GetAllChatMessagesForKlicChatDocument = gql`
  query getAllChatMessagesForKlicChat($eventId: String, $channelId: String) {
    getAllChatMessagesForKlicChat(eventId: $eventId, channelId: $channelId) {
      error
      channel
      messages {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const GetUserByEmailDocument = gql`
  query getUserByEmail($email: String) {
    getUserByEmail(email: $email) {
      error
      user {
        avatar
        channelId
        createdAt
        email
        firstName
        id
        lastName
        updatedAt
        userId
        userName
        userData {
          avatar
          channelId
          displayEmail
          displayName
          email
          id
          firstName
          lastName
          role
          username
          venueId
        }
      }
    }
  }
`;
export const GetVenueForUserDocument = gql`
  query getVenueForUser($userId: String) {
    getVenueForUser(userId: $userId) {
      venue {
        id
        createdAt
        item
        updatedAt
        venueData {
          description
          name
          owner
        }
      }
      message
    }
  }
`;
export const UpdateUserProfileDocument = gql`
  mutation updateUserProfile($updateUserPayload: UpdateUserInput) {
    updateUserProfile(updateUserPayload: $updateUserPayload) {
      user {
        id
        userId
        channelId
        userName
        email
        firstName
        lastName
        avatar
        createdAt
        updatedAt
      }
      error
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper
) {
  return {
    getChannelById(
      variables?: IGetChannelByIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChannelByIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChannelByIdQuery>(
            GetChannelByIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getChannelById',
        'query'
      );
    },
    listAllEventsForChannel(
      variables?: IListAllEventsForChannelQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IListAllEventsForChannelQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IListAllEventsForChannelQuery>(
            ListAllEventsForChannelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'listAllEventsForChannel',
        'query'
      );
    },
    listEventCategories(
      variables?: IListEventCategoriesQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IListEventCategoriesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IListEventCategoriesQuery>(
            ListEventCategoriesDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'listEventCategories',
        'query'
      );
    },
    listEventTypes(
      variables?: IListEventTypesQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IListEventTypesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IListEventTypesQuery>(
            ListEventTypesDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'listEventTypes',
        'query'
      );
    },
    getEventById(
      variables?: IGetEventByIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetEventByIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetEventByIdQuery>(GetEventByIdDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getEventById',
        'query'
      );
    },
    getLandingVideos(
      variables?: IGetLandingVideosQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetLandingVideosQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetLandingVideosQuery>(
            GetLandingVideosDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getLandingVideos',
        'query'
      );
    },
    createEventV2(
      variables?: ICreateEventV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateEventV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateEventV2Mutation>(
            CreateEventV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'createEventV2',
        'mutation'
      );
    },
    attendEvent(
      variables?: IAttendEventMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IAttendEventMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAttendEventMutation>(AttendEventDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'attendEvent',
        'mutation'
      );
    },
    onAttendUpdate(
      variables?: IOnAttendUpdateSubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnAttendUpdateSubscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnAttendUpdateSubscription>(
            OnAttendUpdateDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'onAttendUpdate',
        'subscription'
      );
    },
    sendMessageEventChat(
      variables?: ISendMessageEventChatMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ISendMessageEventChatMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISendMessageEventChatMutation>(
            SendMessageEventChatDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'sendMessageEventChat',
        'mutation'
      );
    },
    onSendMessageEventChat(
      variables?: IOnSendMessageEventChatSubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnSendMessageEventChatSubscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnSendMessageEventChatSubscription>(
            OnSendMessageEventChatDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'onSendMessageEventChat',
        'subscription'
      );
    },
    getAllChatMessagesForEventChat(
      variables?: IGetAllChatMessagesForEventChatQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetAllChatMessagesForEventChatQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetAllChatMessagesForEventChatQuery>(
            GetAllChatMessagesForEventChatDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getAllChatMessagesForEventChat',
        'query'
      );
    },
    sendMessageKlicChat(
      variables?: ISendMessageKlicChatMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ISendMessageKlicChatMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISendMessageKlicChatMutation>(
            SendMessageKlicChatDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'sendMessageKlicChat',
        'mutation'
      );
    },
    onSendMessageKlicChat(
      variables?: IOnSendMessageKlicChatSubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnSendMessageKlicChatSubscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnSendMessageKlicChatSubscription>(
            OnSendMessageKlicChatDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'onSendMessageKlicChat',
        'subscription'
      );
    },
    getAllChatMessagesForKlicChat(
      variables?: IGetAllChatMessagesForKlicChatQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetAllChatMessagesForKlicChatQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetAllChatMessagesForKlicChatQuery>(
            GetAllChatMessagesForKlicChatDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getAllChatMessagesForKlicChat',
        'query'
      );
    },
    getUserByEmail(
      variables?: IGetUserByEmailQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetUserByEmailQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetUserByEmailQuery>(
            GetUserByEmailDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getUserByEmail',
        'query'
      );
    },
    getVenueForUser(
      variables?: IGetVenueForUserQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetVenueForUserQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetVenueForUserQuery>(
            GetVenueForUserDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getVenueForUser',
        'query'
      );
    },
    updateUserProfile(
      variables?: IUpdateUserProfileMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateUserProfileMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateUserProfileMutation>(
            UpdateUserProfileDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateUserProfile',
        'mutation'
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
